import Base from '../Base';

export default class SettingToken extends Base {
    static url = '/api/setting/token';
}
